import type { ReactNode } from "react";
import Link from "next/link";

const BASE = "rounded-2xl border border-white/10 bg-white/5";
const INTERACTIVE = "block transition-colors hover:border-white/20 hover:bg-white/[0.07]";

/**
 * Единая карточка: светлая граница отделяет блок от полотна. Легаси-классы
 * glass-* рисуют границу цветом фона (rgba(32,46,100,.4)) — из-за этого
 * карточки сливались и страницы выглядели «без порядка». Здесь граница светлая.
 */
export default function GlassCard({
  children,
  href,
  className = "",
  interactive,
  padded = true,
}: {
  children: ReactNode;
  /** Если задан — карточка становится ссылкой. */
  href?: string;
  className?: string;
  interactive?: boolean;
  /** false — без внутренних отступов, для карточек с картинкой во всю ширину. */
  padded?: boolean;
}) {
  const classes = `${BASE} ${padded ? "p-5 md:p-6" : ""} ${
    href || interactive ? INTERACTIVE : ""
  } ${className}`;

  if (href) {
    return (
      <Link href={href} className={classes}>
        {children}
      </Link>
    );
  }
  return <div className={classes}>{children}</div>;
}
